import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/layout.vue'
import Passport from '@/passport/passport.vue'
// import LaspLayout from '@/lasp/laspLayout.vue'
// import IntroduceLayout from '@/introduce/introduceLayout.vue'

//
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   component: Layout,
    //   name: 'Layout',
    //   redirect: '/introduce',
    //   children: [
    //     {
    //         path: '/lasp',
    //         component: LaspLayout,
    //         redirect: '/lasp/home',
    //         children: [
    //           {
    //               path: 'nnLibrary',
    //               name: 'PeriodicTable',
    //                component: () => import('@/lasp/nnlibrary'),
    //           },
    //            {
    //               path: 'home',
    //               name: 'LaspHome',
    //                component: () => import('@/lasp/home'),
    //             }
    //         ]
    //     },
    //     {
    //         path: '/introduceLayout',
    //         component: IntroduceLayout,
    //         redirect: '/introduce/home',
    //         children: [
    //           {
    //               path: 'home',
    //               name: 'IntroduceHome',
    //                component: () => import('@/introduce/home'),
    //             }
    //         ]
    //     },
    //   ]
    // }
     {
      path: '/',
      component: Layout,
      name: 'Layout',
      redirect: '/lasp',
    },
     {
      path: '/passport',
      component: Passport,
      name: 'Layout',
       redirect: '/passport/login',
       children: [
         {
              path: 'login',
              name: 'Login',
              component: () => import('@/passport/login'),
                   meta: {
                   title:'Login'
                }
         },
         {
              path: 'register',
              name: 'Register',
              component: () => import('@/passport/register'),
                   meta: {
                   title:'Register'
                }
        },
        {
            path: 'downtmp',
            name: 'LaspDowntmp',
            component: () => import('@/lasp/downtmp'),
                 meta: {
                 title: '',
                 icon:''
          },
        },
        {
            path: 'downbyd',
            name: 'LaspDownBYD',
            component: () => import('@/lasp/downbyd'),
                 meta: {
                 title: '',
                 icon:''
          },
        },
         {
           path: 'reset',
           name: 'Reset',
           component: () => import('@/passport/reset'),
           meta: {
             title:'Reset Password'
           }
         }
      ]
    },
    {
          path: '/lasp',
          component: Layout,
      redirect: '/lasp/laspHome',
      name: 'Lasp',
      meta: {
        icon: 'lasp',
        title:'Lasp'
          },
      children: [
           {
                path: 'laspHome',
                name: 'LaspHome',
          component: () => import('@/lasp/home'),
                   meta: {
                     title: 'Home',
                     icon:'home'
                }
              } ,
          {
                path: 'history',
                name: 'LaspHistory',
                component: () => import('@/lasp/history'),
                meta: {
                  title: 'LASP History',
                  icon:'history'
                }
          },
          {
                path: 'mannual',
                name: 'LaspMannual',
            component: () => import('@/lasp/mannual'),
                  meta: {
                    title: 'Mannual',
                    icon:'mannual'
                }
            },
            {
                path: 'examples',
                name: 'LaspExamples',
              component: () => import('@/lasp/examples'),
                   meta: {
                     title: 'Examples',
                     icon:'examples'
                }
          },
            {
                path: 'nnLibrary',
                name: 'LaspNNLibrary',
                  component: () => import('@/lasp/nnLibrary'),
                   meta: {
                     title: 'CPUNN Library',
                     icon:'nnLibrary'
                }
          },
            {
                path: 'gpunnLibrary',
                name: 'LaspGPUNNLibrary',
                  component: () => import('@/lasp/gpunnLibrary'),
                   meta: {
                     title: 'GPUNN Library',
                     icon:'nnLibrary'
                }
          },
            {
                path: 'download',
                name: 'LaspDownload',
              component: () => import('@/lasp/download'),
                   meta: {
                     title: 'LASP Download',
                     icon:'download'
                }
          },
            {
                path: 'methodology',
                name: 'LaspMethodology',
                  component: () => import('@/lasp/methodology'),
                   meta: {
                     title: 'LASP Methodology',
                     icon:'methodology'
                }
          },
            {
                path: 'applications',
                name: 'LaspApplications',
              component: () => import('@/lasp/applications'),
                   meta: {
                     title: 'LASP Applications',
                     icon:'applications'
                }
          },
             {
                path: 'view',
                name: 'LaspView',
               component: () => import('@/lasp/view'),
                   meta: {
                     title: 'LASP View',
                     icon:'view'
                }
          },
             {
                path: 'tutorial',
                name: 'LaspTutorial',
               component: () => import('@/lasp/tutorial'),
                   meta: {
                     title: 'LASP Tutorial',
                     icon:'tutorial'
               },

        },
          {
              path: 'calculation',
              name: 'LaspCalculation',
              component: () => import('@/lasp/calculation'),
              meta: {
                  title: 'LASP Calculation',
                  icon:'calculation'
              },
          },
          {
              path: 'communicationGroup',
              name: 'LaspCommunicationGroup',
              component: () => import('@/lasp/communicationGroup'),
              meta: {
                  title: 'Communication Group',
                  icon:'courses'
              },
          },
        //       {
        //       path: '/videoPlayer',
        //       component: () => import('@/components/videoPlayer'),
        //       name: 'VideoPlayer',
        //       meta: {
        //         title: 'VideoPlayer',
        //         hide:true
        //       }
        // }
            //  {
            //     path: 'liuGroupAtFudan',
            //     name: 'LaspLiuGroupAtFudan',
            //    component: () => import('@/lasp/liuGroupAtFudan'),
            //        meta: {
            //        title:'LiuGroup at Fudan'
            //     }
            // }
          ]
        },
        {
            path: '/introduce',
            component: Layout,
          redirect: '/introduce/introduceHome',
          name: 'Introduce',
            meta: {
              icon: 'introduce',
              title:'Introduce'
          },
            children: [
              {
                  path: 'introduceHome',
                  name: 'IntroduceHome',
                component: () => import('@/introduce/home'),
                    meta: {
                      title: 'Home',
                     icon:'home'
                }
              },
               {
                  path: 'publications',
                  name: 'IntroducePublications',
                 component: () => import('@/introduce/publications'),
                    meta: {
                      title: 'Publications',
                      icon:'publications'
                }
              },
                {
                  path: 'research',
                  name: 'IntroduceResearch',
                  component: () => import('@/introduce/research'),
                    meta: {
                      title: 'Research',
                      icon:'research'
                }
              },
                 {
                  path: 'people',
                  name: 'IntroducePeople',
                   component: () => import('@/introduce/people'),
                    meta: {
                      title: 'People',
                      icon:'people'
                }
              },
                  {
                  path: 'courses',
                  name: 'IntroduceCourses',
                    component: () => import('@/introduce/courses'),
                    meta: {
                      title: 'Courses',
                      icon:'courses'
                }
              },
                   {
                  path: 'positionOpening',
                  name: 'IntroducePositionOpening',
                   component: () => import('@/introduce/positionOpening'),
                    meta: {
                      title: 'PositionOpening',
                      icon:'positionOpening',
                      hide:true
                }
              },
                // {
                //   path: 'contactInformation',
                //   name: 'IntroduceContactInformation',
                //   component: () => import('@/introduce/contactInformation'),
                //     meta: {
                //    title:'ContactInformation'
                //   }
                // }
            ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js